export const environment = {
  production: true,
  apiUrl: '/api',
  appName: 'SyncTube.live',
};
